import { useEffect, useState } from "react";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Header from "./header";
import { useAuth } from "context";
import { NavbarAlert } from "examples/Alert";
import PendingWelcomeBonusBanner from "components/PendingWelcomeBonusBanner";
import { getNsuCashbackDetails } from "layouts/dashboard/_request";

function OrderHistory() {
  const { miniSidenav } = useAuth();
  const [pendingWelcomeBonuses, setPendingWelcomeBonuses] = useState();

  useEffect(() => {
    const fetchPendingWelcomeBonuses = async () => {
      try {
        const {
          data: { success, data },
        } = await getNsuCashbackDetails();
        if (success) {
          setPendingWelcomeBonuses(data.pendingWelcomeBonuses);
        }
      } catch (e) {
        console.log(e);
      }
    };
    fetchPendingWelcomeBonuses();
  }, []);

  return (
    <>
      <DashboardNavbar />
      <NavbarAlert />
      <DashboardLayout>
        <MDBox
          sx={{
            mt: 10,
            "@media (max-width:767px)": {
              mt: 10,
            },
          }}
        >
          {miniSidenav && (
            <MDBox
              sx={{
                "@media (max-width:767px)": {
                  mb: 1,
                },
              }}
              className="text-lg text-black font-medium"
            >
              Order History
            </MDBox>
          )}
          <PendingWelcomeBonusBanner items={pendingWelcomeBonuses} />
          <Header />
        </MDBox>
      </DashboardLayout>
    </>
  );
}

export default OrderHistory;
